import { getPhysicalRing, getVariantEnvironment } from 'owa-metatags';
import { isMiniFeatureEnabled } from 'owa-mini-feature-flags';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';

/**
 * Returns true if feature flag is enabled and the user is not in BlackForest
 * @returns
 */
export const shouldShowFeedbackLink = () => {
    if (!isMiniFeatureEnabled('mini-feedback-link')) {
        return false;
    }

    if (getPhysicalRing() === 'BlackForest') {
        return false;
    }

    if (getVariantEnvironment() === 'BlackForest') {
        return false;
    }

    if (getUserConfiguration()?.IsConsumerChild && isConsumer()) {
        return false;
    }

    return true;
};
